import React from "react";
import "./webReport.css";
import Title from "../../components/Title";
import Item from "../../components/Item";
import { formattedDate } from "./helperFunctions";
import ChallengeSummary from "./challengeSummary";
import CoverPage from "./coverPage";
const LABEL_DEFINITION = {
  inspector: {
    type: "short-label",
    displayName: "Inspector",
  },
  inspectedDate: {
    type: "short-label",
    displayName: "Inspected Date",
  },
  name: {
    type: "short-label",
    displayName: "Name",
  },
  info: {
    type: "long-field-content",
    displayName: "Note",
  },
  apn: {
    type: "long-label",
    displayName: "Parcel Number",
  },
  address: {
    type: "long-field-content",
    displayName: "Address",
  },
  city: {
    type: "short-label",
    displayName: "City",
  },
  state: {
    type: "short-label",
    displayName: "State",
  },
  zipCode: {
    type: "short-label",
    displayName: "Postal Code",
  },
  year_build: {
    type: "short-label",
    displayName: "Year Built",
  },
  stories: {
    type: "long-label",
    displayName: "Number of Stories",
  },
  floor_area: {
    type: "short-label",
    displayName: "Square Feet",
  },
  report_type: {
    type: "short-label",
    displayName: "Report Type",
  },
  house_type: {
    type: "short-label",
    displayName: "House Type",
  },
};

const FIELDS_PER_ROW = [2, 3, 3, 2]; // Adjust this number as needed

const MetaDataSection = ({ metaDataItems, challenges }) => {
  const {
    "Project Information": projectInfo,
    Agents: agents,
    Client: client,
    Company: company,
    "Profile Image": profileImage,
    Address: address,
    User: user,
  } = metaDataItems;

  const {
    inspectorName,
    name,
    info: note,
    created_at: createdDate,
    propertyDetails,
    summary,
  } = projectInfo;

  const ClientDetailsSection = (
    <div className="info-row">
      <div className="field short-label">
        <span className="label">Name</span>
        <span className="field-content">{client?.name || "{Client Name}"} </span>
      </div>
      <div className="field long-field-content">
        <span className="label">Note</span>
        <span className="field-content">{client?.note}</span>
      </div>
    </div>
  );

  let currentRowIndex = 0;
  const PropertyDetails = propertyDetails
    .filter((item) => item.value)
    .reduce((rows, item) => {
      // Create new row array if it doesn't exist
      if (!rows[currentRowIndex]) {
        rows[currentRowIndex] = [];
      }

      // Add the field to the current row
      rows[currentRowIndex].push(
        <div
          key={item.key}
          className={`field ${LABEL_DEFINITION[item.key]?.type}`}
        >
          <span className="label">
            {LABEL_DEFINITION[item.key]?.displayName}
          </span>
          <span className="field-content">{item.value}</span>
        </div>
      );

      if (rows[currentRowIndex].length === FIELDS_PER_ROW[currentRowIndex]) {
        currentRowIndex++;
      }

      return rows;
    }, []);

  const PropertyDetailsSection = (
    <>
      {PropertyDetails.map((row, index) => (
        <div key={index} className="info-row">
          {row}
        </div>
      ))}
    </>
  );

  const OverviewSection = <div className="info-row">{summary}</div>;

  return (
    <>
      <div className="metadata-container" id="section-cover-page">
        <CoverPage
          agents={agents}
          client={client}
          company={company}
          profileImage={profileImage}
          address={address}
          user={user}
          inspectedDate={formattedDate(createdDate)}
        />
      </div>
      <ChallengeSummary challenges={challenges} />
      <div className="metadata-container" id="project information">
        <Title text="Project Information" />
        <Item text="Client Details" children={ClientDetailsSection} />
        <Item text="Property Details" children={PropertyDetailsSection} />
      </div>
      <div className="metadata-container" id="project overview">
        <Title text="Project Overview" />
        <Item children={OverviewSection} showDivider={false} />
      </div>
    </>
  );
};

export default MetaDataSection;
